export const COURSE_CODE = {
  SAT_DEMO: 'SATDEMO',
  INDIA_MATH: 'INDMTH',
};
